import { render, staticRenderFns } from "./the-games-development-process.vue?vue&type=template&id=53c236f9&scoped=true&"
import script from "./the-games-development-process.vue?vue&type=script&lang=js&"
export * from "./the-games-development-process.vue?vue&type=script&lang=js&"
import style0 from "./the-games-development-process.vue?vue&type=style&index=0&id=53c236f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c236f9",
  null
  
)

export default component.exports